import jQuery from 'jquery';

const affiliateDomains = ["otsuka"];

const handleConfirm = (text,url)=>{
    if(confirm(text)){
    	window.open(url,"newWindow");
    }
}

(function($, window, document) {
  var Plugin, defaults, pluginName;
  pluginName = "xwindow";
  defaults = {
    type: "newWindow",
    width: 660,
    height: 760
  };

  Plugin = (function() {
    function Plugin(element, options) {
      this.element = element;
      this.settings = $.extend({}, defaults, options);
      this._defaults = defaults;
      this._name = pluginName;
      this.funcs = {
      	popup: this.popup,
      	newWindow: this.newWindow,
      	prompt: this.prompt
      }
      this.init();
    }

    Plugin.prototype.init = function() {
      this.$el = $(this.element);
      var type = this.settings.type;
      var fn = this.funcs[type];
      this.$el.on("click",$.proxy(fn,this));
    };

     Plugin.prototype.newWindow = function(e) {
    	e.preventDefault();
    	var $el = $(e.currentTarget);
        window.open($el.attr("href"),"newWindow");
    };

    Plugin.prototype.prompt = function(e) {
    	e.preventDefault();

        const $disclaimer = $('#disclaimer');
        console.log($disclaimer.data('affiliate'));
        const url = e.currentTarget.getAttribute("href");
        const { hostname } = new URL(url,window.location.origin);

        const isAffiliate = affiliateDomains.some((affiliateDomain) =>
            hostname.includes(affiliateDomain)
        )

        const hasAffiliateDisclaimerText = $disclaimer.length > 0 && $disclaimer.data('affiliate');
        const hasDisclaimerText = $disclaimer.length > 0 && $disclaimer.data('text');

        if(hasAffiliateDisclaimerText && isAffiliate){
            return handleConfirm($disclaimer.data('affiliate'),url);
        }

        if(hasDisclaimerText){
            return handleConfirm($disclaimer.data('text'),url);
        }

        return this.newWindow(e);
    };

    Plugin.prototype.popup = function(e) {
    	e.preventDefault();
    	var $el = $(e.currentTarget);
    	var newWindow = window.open($el.attr("href"), "popup", "toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=1,width=" + this.settings.width + "," + this.settings.height);
    	newWindow.focus();
    	newWindow.opener = window;
    }

    return Plugin;

  })();
  return $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        return $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  };
})(jQuery, window, document);

	
jQuery(document).ready(()=>{
  jQuery('a.xLink').xwindow({type:"prompt"});
  jQuery('a.xOpen').xwindow();
  jQuery('a.xPopup').xwindow({
    type : "popup"
  });
})
	
